import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import {
    Goal,
    Evaluation,
    postIndividualEvaluation,
    updateIndividualEvaluation,
    getIndividualEvaluation,
    getToImprove,
    updateEvaluationStatus,
    getIndividualLog,
} from '../../service/PerformanceAPI';
import { connect } from 'react-redux'
import $ from 'jquery';
import EvaluationButton from '../../components/EvaluationButton';
import moment from 'moment';
import '../Goal/Evaluation.css';
import ReadMore from '../../components/ReadMore';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import EvaluationLog from '../../components/EvaluationLog';
import EvaluationNoData from '../../components/Evaluation/EvaluationNoData';
import ViewEvaluation from '../../components/Evaluation/ViewEvaluation';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import EmpEvaluation from './EmpEvaluation';
import { encryptStorage } from '../../constant'

function PerformanceEvaluation({ websocket }) {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [details, setDetails] = useState(state);
    const [individualGoal, setIndividualGoal] = useState([]);
    const [teamGoal, setTeamGoal] = useState([]);
    const [pageMode, setPageMode] = useState(false);
    const [thingsToImprove, setThingsToImprove] = useState([]);
    const [newtti, setNewTti] = useState([]);
    const [flag, setflag] = useState('false');
    const [Pyramid, setPyramid] = useState(false);
    const [ImproveFlag, setImproveFlag] = useState(false);
    const [logs, setLogs] = useState([]);
    const [readMore, setReadMore] = useState(false);
    const [evaStatus, setEvaStatus] = useState('')
    const [HrComments, setHrComments] = useState('')
    const [logEvaluation, setLogEvaluation] = useState([]);
    const [logTotal, setLogTotal] = useState([]);
    const [logImprove, setLogImprove] = useState([]);
    const [logShow, setLogShow] = useState(false);





    const [evaluationId, setEvaluationId] = useState();

    let empEva = [
        {
            heading: 1,
            description: '',
            rating: '',
            total: '',
            role: 'Team Member',
        },
        {
            heading: 2,
            description: '',
            rating: '',
            total: '',
            role: 'Team Member',
        },
        {
            heading: 3,
            description: '',
            rating: '',
            total: '',
            role: 'Team Member',
        },
        {
            heading: 4,
            description: '',
            rating: '',
            total: '',
            role: 'Team Member',
        },
    ];

    let managerEva = [
        {
            heading: 1,
            description: '',
            rating: '',
            total: '',
            role: 'Manager',
        },
        {
            heading: 2,
            description: '',
            rating: '',
            total: '',
            role: 'Manager',
        },
        {
            heading: 3,
            description: '',
            rating: '',
            total: '',
            role: 'Manager',
        },
        {
            heading: 4,
            description: '',
            rating: '',
            total: '',
            role: 'Manager',
        },
    ];

    let totalEva = [
        {
            role: 'Team Member',
            grand_total: 0,
            grand_rating: '',
        },
        {
            role: 'Manager',
            grand_total: 0,
            grand_rating: '',
        },
    ];

    let evaluationDetails = {
        status: '',
        comments: '',
    };

    let EmployeeValidation = [
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        }
    ]

    let ManagerValidation = [
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        },
        {
            Validation: '',
            Rating: ''
        }
    ]

    const [Evaluation, setEvaluation] = useState(evaluationDetails);
    const [employeeEvaluation, setEmployeeEvaluation] = useState(empEva);
    const [managerEvaluation, setManagerEvaluation] = useState(managerEva);
    const [total, setTotal] = useState(totalEva);
    const [thingsToImproveEvaluation, setThingsToImproveEvaluation] = useState([]);
    const [EmpName, setEmpName] = useState('');
    const [EmpDomain, setEmpDomain] = useState('');
    const [breadCrumbsData, setbreadCrumbsData] = useState([])
    const [customStartEvaluation, setcustomStartEvaluation] = useState(false);
    const [employeeValidation, setEmployeeValidation] = useState(EmployeeValidation)
    const [managerValidation, setManagerValidation] = useState(ManagerValidation)



    useEffect(() => {
        getThingsToImprove();
        loadData();
    }, [logEvaluation,]);

    useEffect(() => {
        setDetails(state)
    }, [state])

    useEffect(() => {
        loadData();
    }, [details.evaluationPeriodId, details])

    useEffect(() => {
        if (details?.currentEvaluation == 1) {
            if (details.role === 'Team Member') {
                let endDate = moment(details?.endDate).subtract(21, 'days').format('MM-DD-YY');
                if (moment().format('MM-DD-YY') >= endDate) {
                    setcustomStartEvaluation(true)
                }
            }
            else if (details.role === 'Manager') {
                let endDate = moment(details?.endDate).subtract(14, 'days').format('MM-DD-YY');
                if (moment().format('MM-DD-YY') >= endDate) {
                    setcustomStartEvaluation(true)
                }
            }
            else if (details.role === 'Hr Manager') {
                let endDate = moment(details?.endDate).subtract(7, 'days').format('MM-DD-YY');
                if (moment().format('MM-DD-YY') >= endDate) {
                    setcustomStartEvaluation(true)
                }
            }
        }
    }, [details.currentEvaluation,])



    const loadData = async () => {

        let goalData = {
            employeeId: details.empId,
            evaluation_period_id: details.evaluationPeriodId,
            domain: details.Domain,
        };


        let result = await Goal(goalData);
        setIndividualGoal(result.data.ResponseData.individual);
        setTeamGoal(result.data.ResponseData.team);

        let evaluationData = {
            emp_id: details.empId,
            evaluation_period_id: details.evaluationPeriodId,
            role: details.role,
        };



        let evaluationResult = await getIndividualEvaluation(evaluationData);
        if (evaluationResult.data?.empName) setEmpName(evaluationResult.data?.empName);
        if (evaluationResult.data?.domain) setEmpDomain(evaluationResult.data?.domain);
        setbreadCrumbsData(state?.View ? [
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'Team Directory', path: '/teamdirectory', isActive: true },
            { title: `${evaluationResult.data?.empName}`, path: '', isActive: true },
            { title: 'Performance Evaluation', path: '', isActive: false },
        ] : details.role === 'Team Member' ? [
            { title: 'Dashboard', path: '/overview', isActive: true },
            encryptStorage.getItem('role') === 'Team Member' ? { title: 'My Performance', path: '', isActive: true } : { title: 'Team Member', path: '', isActive: true },
            { title: 'Performance', path: '/performance', isActive: true, state: { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } } },
            { title: 'Performance Evaluation', path: '', isActive: false }
        ] : [
            { title: 'Dashboard', path: '/overview', isActive: true },
            { title: 'Team Member', path: '', isActive: true },
            { title: 'Performance', path: '/performance', isActive: true, state: { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } } },
            { title: 'Performance Evaluation', path: '', isActive: false }
        ])
        if (evaluationResult.data.ResponseData?.evaluation_id) {

            setEvaluationId(evaluationResult.data.ResponseData?.evaluation_id);
            setEmployeeEvaluation(evaluationResult.data.ResponseData?.employeeEvaluation);
            setManagerEvaluation(evaluationResult.data.ResponseData?.managerEvaluation);
            setThingsToImproveEvaluation(evaluationResult.data.ResponseData?.thingsToImprove);
            setTotal(evaluationResult.data.ResponseData?.total);

            setPageMode(true);
            setLogs(evaluationResult.data.logs);
            setEvaStatus(evaluationResult.data.ResponseData?.status)
            setEvaluation({ ...Evaluation, comments: evaluationResult.data.ResponseData?.comments })
        }
        else {
            setEmployeeEvaluation(empEva);
            setManagerEvaluation(managerEva);
            setTotal(totalEva);
            setPageMode(false);
            setLogs([]);
            setEvaStatus('')
            setEvaluation(evaluationDetails)
            setEvaluationId()
            setThingsToImproveEvaluation([])
        }
    };

    const bindData = () => {
        let data = [];
        thingsToImproveEvaluation.map((ev) => {
            
            if (typeof ev === 'string') {
                data.push(ev);
            } else {
                thingsToImprove.map((ti) => {
                    if (ti.id === ev) {
                        data.push(ti.value);
                    }
                });
            }
        });

        return data.map((datum) => {
            return (
                <div className="accordion-item my-2 border-0 px-0 performance-table">
                    <label className="form-check-label form-readonly-label font-12 medium-text table-inlinetext-clr pb-3">
                        <img src="/Images/bulletedlisticon.svg" className="me-2" />
                        {datum}
                    </label>
                </div>
            );
        });
    };

    const getThingsToImprove = async () => {
        let Result = await getToImprove();
        setThingsToImprove(Result.data.ResponseData);
    };

    const onChangeToImprove = (e, i) => {
        //
        let inputField = thingsToImprove;
        inputField[i].checked = e.target.checked;
        setThingsToImprove(inputField);
        setflag(!flag);
    };

    const onChangeNewinput = (e, i) => {
       
        let inputField = newtti;

        inputField[i] = { ...newtti[i], value: $('#toimprove-' + i).val() };
        setNewTti(inputField);
        setflag(!flag);
    };

    const onChangeNewCheckbox = (e, i) => {
        //
        let inputField = newtti;
        inputField[i] = { ...newtti[i], checked: e.target.checked };
        setNewTti(inputField);
        setflag(!flag);
        // inputField[index].checked = e.target.checked
    };

    const bindThingsToImprove = () => {
        return thingsToImprove.map((improve, i) => {

            return (
                <div className="form-check my-1">
                    <input
                        onClick={(e) => {
                            onChangeToImprove(e, i);
                        }}
                        checked={improve.checked}
                        className="form-check-input checkbox-sty"
                        value={improve.id}
                        type="checkbox"
                        id={'flexCheckChecked-' + i}
                    />
                    <label className="form-check-label font-12 medium-text table-inlinetext-clr pb-3" htmlFor={'flexCheckChecked-' + i}>
                        {improve.value}
                    </label>
                </div>
            );
        });
    };

    const AddCheckBox = () => {
        //
        let obj = {
            id: 5,
            checked: false,
            value: '',
        };
        let newobj = [];
        newobj.push(obj);
        setNewTti([...newtti, ...newobj]);
    };

    const CheckBox = () => {
       
        return newtti.map((obj, i) => {
            {

            }
            return (
                <div className="form-check my-1">
                    <input
                        onClick={(e) => {
                            onChangeNewCheckbox(e, i);
                        }}
                        checked={obj.checked}
                        className="form-check-input checkbox-sty"
                        type="checkbox"
                        id={'flexCheckChecked-' + i}
                    />
                    <input
                        name="value"
                        onChange={(e) => {
                            onChangeNewinput(e, i);
                        }}
                        value={obj.value}
                        className="mb-2"
                        type="text"
                        id={`toimprove-` + i}
                        for={'flexCheckChecked-' + i}
                    />
                </div>
            );
        });
    };

    const onchangeEmp = (e, index, stateToDuplicate, stateToSet) => {
       
        // let data = employeeEvaluation;
        // data[index] = { ...data[index], description: e.target.value };
        // setEmployeeEvaluation(data);
        // setflag(!flag);
        let data = stateToDuplicate;
        data[index] = { ...data[index], description: e.target.value };
        stateToSet(data);
        setflag(!flag);
    };

    const onchangeRatingEmp = (e, index, stateToDuplicate, stateToSet) => {
       
        // let data = employeeEvaluation;
        // data[index] = { ...data[index], rating: e.target.value };
        // setEmployeeEvaluation(data);
        // onchangeTotalEmp(parseInt(e.target.value), index);
        // setflag(!flag);

        let data = stateToDuplicate;
        data[index] = { ...data[index], rating: e.target.value };
        stateToSet(data);
        onchangeTotalEmp(parseInt(e.target.value), index, stateToDuplicate, stateToSet);
        setflag(!flag);
    };

    // const onchangeManager = (e, index) => {
    //     let data = managerEvaluation;
    //     data[index] = { ...data[index], description: e.target.value };
    //     setManagerEvaluation(data);
    //     setflag(!flag);
    // };

    // const onchangeRatingManager = (e, index) => {
    //    
    //     let data = managerEvaluation;
    //     data[index] = { ...data[index], rating: e.target.value };
    //     setManagerEvaluation(data);
    //     onchangeTotalManager(parseInt(e.target.value), index);
    //     setflag(!flag);
    // };

    const onchangeTotalEmp = (e, index, stateToDuplicate, stateToSet) => {
        // let result = index == 0 ? 4 * e : index == 1 ? 3 * e : index == 2 ? 2 * e : index == 3 ? 1 * e : null;
        // let data = employeeEvaluation;
        // data[index] = { ...data[index], total: result };
        // setEmployeeEvaluation(data);
        // empTotalCalculation();
        // setflag(!flag);
        let result = index == 0 ? 4 * e : index == 1 ? 3 * e : index == 2 ? 2 * e : index == 3 ? 1 * e : null;
        let data = stateToDuplicate;
        data[index] = { ...data[index], total: result };
        stateToSet(data);
        empTotalCalculation(stateToDuplicate);
        setflag(!flag);
    };

    // const onchangeTotalManager = (e, index) => {
    //     let result = index == 0 ? 4 * e : index == 1 ? 3 * e : index == 2 ? 2 * e : index == 3 ? 1 * e : null;
    //     let data = managerEvaluation;
    //     data[index] = { ...data[index], total: result };
    //     setManagerEvaluation(data);
    //     managerTotalCalculation();
    //     setflag(!flag);
    // };

    const empTotalCalculation = (stateToDuplicate) => {
        // let emp_total = 0;
        // employeeEvaluation.map((ev) => {
        //     emp_total += ev.total;
        // });
        // let data = total;
        // data[0] = { ...data[0], grand_total: emp_total };
        // setTotal(data);
        // setflag(!flag);
        // calculateRating('emp', 0);
        let emp_total = 0;
        stateToDuplicate.map((ev) => {
            emp_total += ev.total;
        });
        let data = total;
        if (stateToDuplicate == employeeEvaluation) data[0] = { ...data[0], grand_total: emp_total };
        else data[1] = { ...data[1], grand_total: emp_total };
        setTotal(data);
        setflag(!flag);
        if (stateToDuplicate == employeeEvaluation) calculateRating('emp', 0);
        else calculateRating('Manager', 1);
    };

    // const managerTotalCalculation = () => {
    //     let emp_total = 0;
    //   
    //     managerEvaluation.map((ev) => {
    //         emp_total += ev.total;
    //         // 
    //     });

    //     let data = total;
    //     data[1] = { ...data[1], grand_total: emp_total };
    //     setTotal(data);
    //     setflag(!flag);

    //     calculateRating('Manager', 1);
    // };

    const calculateRating = (value, i) => {
        let data = total;
        let emptotal = value === 'Manager' ? data[1]?.grand_total : data[0]?.grand_total;
        if (emptotal >= 44) {
            data[i].grand_rating = 'A+';
        } else if (emptotal >= 37) {
            data[i].grand_rating = 'A-';
        } else if (emptotal >= 30) {
            data[i].grand_rating = 'B+';
        } else if (emptotal >= 24) {
            data[i].grand_rating = 'B-';
        } else if (emptotal >= 17) {
            data[i].grand_rating = 'C+';
        } else if (emptotal >= 10) {
            data[i].grand_rating = 'C-';
        }
        setTotal(data);
        setflag(!flag);
    };

    const showThingsToImprove = () => {
        let value = [];
        thingsToImproveEvaluation.map((result) => {
           

            if (typeof result === 'string') {
                let newEvaluation = {
                    id: 5,
                    checked: true,
                    value: result,
                };
                value.push(newEvaluation);
            } else {
                thingsToImprove.map((toimprove, i) => {
                    if (result == toimprove.id) {
                        setflag(true);
                        let improve = thingsToImprove;
                        improve[i] = { ...improve[i], checked: true };
                        setThingsToImprove(improve);
                    }
                });
            }
        });
        // if (newtti.length > 0) {
        // setNewTti([...value, ...newtti]);
        // }
        // else {
        setNewTti([...value]);
        // }
    };

    const validationHr = (status) => {
       
        if (status === 'Rejected') {
            if (Evaluation.comments !== '' && Evaluation.comments !== null) {
                return true;
            } else {
                setHrComments("Comments Required"); return false;
            }

        } else return true;
    };

    const validation = (value) => {
        if (value == managerEvaluation) {
            return (
                (value.every((data) => data.description.trim() != '' && data.total != 0 && (!OnlyNumberSpecialChar(data.description.trim())) && data.description.trim().length > 3)
                    && (thingsToImprove.some((tti) => (tti.checked && tti.value.trim() != '' && (!OnlyNumberSpecialChar(tti.value.trim())))) || newtti.some(tti => tti.checked && tti.value.trim() != '' && (!OnlyNumberSpecialChar(tti.value.trim())))))
            );
        } else {
           
            // let result = true
            // value?.map((evaluation, i) => {
            //  
            //     if (evaluation?.description?.trim() == '' || evaluation?.rating == '' || evaluation?.rating == '0') {
            //         result = false
            //         let validate
            //         if (value == managerEvaluation) validate = ManagerValidation;
            //         else validate = employeeValidation;
            //         validate[i] = { ...validate[i], Validation: 'Enter comments' }
            //         if (value == managerEvaluation) setManagerValidation(validate);
            //         else setEmployeeValidation(validate);
            //         setflag(!flag)
            //     }
            //     else if (OnlyNumberSpecialChar(evaluation?.description?.trim())) {
            //         result = false
            //         let validate
            //         if (value == managerEvaluation) validate = ManagerValidation;
            //         else validate = employeeValidation;
            //         validate[i] = { ...validate[i], Validation: 'Enter valid comments' }
            //         if (value == managerEvaluation) setManagerValidation(validate);
            //         else setEmployeeValidation(validate);
            //         setflag(!flag)

            //     }
            // })
            // if (value == managerEvaluation) {
            //     let checkTTI = thingsToImprove.some((tti) => (tti.checked && tti.value)) || newtti.some(tti => tti.checked && tti.value)
            //     if (checkTTI) return result; else return false;
            // }
            // return result
            return value.every((data) => data.description != '' && data.total != 0 && (!OnlyNumberSpecialChar(data.description.trim())) && data.description.trim().length > 3);
        }
    };



    const saveEvaluation = async (view, type) => {
        if (pageMode) {

            
            if (
                employeeEvaluation[0].description &&
                employeeEvaluation[0].total &&
                employeeEvaluation[1].description &&
                employeeEvaluation[1].total &&
                employeeEvaluation[2].description &&
                employeeEvaluation[2].total &&
                employeeEvaluation[3].description &&
                employeeEvaluation[3].total
            ) {
               
                let things_to_improve = [];
                thingsToImprove.map((tti) => {
                    if (tti.checked) {
                        things_to_improve.push(tti.id);
                    }
                });
                newtti.map((tti) => {
                    if (tti.checked) {
                        things_to_improve.push(tti.value);
                    }
                });




                let emp_total = 0;
                let manager_total = 0;

                employeeEvaluation.map((ev) => {
                    emp_total += ev.total;
                });

                managerEvaluation.map((ev) => {
                    manager_total += ev.total;
                });

                let data = total;
                data[0] = { ...data[0], grand_total: emp_total };
                setTotal(data);

                let managerdata = total
                data = total
                data[1] = { ...data[1], role: 'Manager', grand_total: manager_total }
                setTotal(data)

                let managerid = details.role == 'Manager' ? encryptStorage.getItem('employeeId') : '';
                let hrid = details.role == 'Hr Manager' ? encryptStorage.getItem('employeeId') : '';

                let updatetData = {
                    evaluation_id: evaluationId,
                    emp_id: details.empId,
                    evaluation_period_id: details.evaluationPeriodId,
                    employeeEvaluation: employeeEvaluation,
                    total: total,
                    manager_id: managerid,
                    status: (evaStatus != 'pending' && evaStatus != '') ? evaStatus : 'pending',
                    hr_id: hrid,
                    comments: null,
                    employeeEvaluation: employeeEvaluation,
                    managerEvaluation: managerEvaluation[0].description !== '' ? managerEvaluation : [],
                    total: total,
                    thingsToImprove: things_to_improve,
                };
                let newObj;
                let role = details.role == 'Manager' || details.role == 'Team Member' ? details.role : '';
                if (type == 'draft') {
                    newObj = {
                        isactive: '0',
                        ispublished: '1',
                        userInRole: role,
                    };
                } else {
                    newObj = {
                        isactive: '1',
                        ispublished: '0',
                        userInRole: role,
                    };
                }

                let newdata = { ...updatetData, ...newObj };

                let resultData = await updateIndividualEvaluation(newdata);
               
                if (resultData.data.ResponseData == 'Successfully updated') {
                   
                    if (type == 'draft') {
                        !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                    }
                    else {
                        if (details.role == 'Manager') {
                            NotificationTrigger({ title: "Evaluation", message: `${EmpName}'s performance evaluation has been updated`, route: `/performanceevaluation`, state: { state: { empId: details.empId, currentEvaluation: details.currentEvaluation, evaluationPeriodId: details.evaluationPeriodId, Domain: details.Domain, role: 'Team Member' } }, to_employee: [details.empId], by: encryptStorage.getItem('employeeId') }, [details.empId], websocket).then(res => {
                                !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                            })
                        }
                        else {
                            NotificationTrigger({ title: "Evaluation", message: 'Your performance evaluation has been updated', route: `/performanceevaluation`, state: { state: { empId: details.empId, currentEvaluation: details.currentEvaluation, evaluationPeriodId: details.evaluationPeriodId, Domain: details.Domain, role: 'Manager' } }, to_employee: [resultData.data.reports_to], by: details.empId }, [resultData.data.reports_to], websocket).then(res => {
                                !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                            })
                        }

                    }
                }
            }
        } else {
            if (
                employeeEvaluation[0].description &&
                employeeEvaluation[0].total &&
                employeeEvaluation[1].description &&
                employeeEvaluation[1].total &&
                employeeEvaluation[2].description &&
                employeeEvaluation[2].total &&
                employeeEvaluation[3].description &&
                employeeEvaluation[3].total
            ) {
               
                let emp_total = 0;

                employeeEvaluation.map((ev) => {
                    emp_total += ev.total;
                    // 
                });

                let data = total;
                data[0].grand_total = emp_total;
                setTotal(data);

                let postData = {
                    emp_id: details.empId,
                    evaluation_period_id: details.evaluationPeriodId,
                    employeeEvaluation: employeeEvaluation,
                    total: total,
                };





                let newObj;
                let role = details.role == 'Manager' || details.role == 'Team Member' ? details.role : '';
                if (type == 'draft') {
                    newObj = {
                        isactive: '0',
                        ispublished: '1',
                        userInRole: role,
                    };
                } else {
                    newObj = {
                        isactive: '1',
                        ispublished: '0',
                        userInRole: role,
                    };
                }

                let newdata = { ...postData, ...newObj };

                let resultData = await postIndividualEvaluation(newdata);
               

                if (resultData.data.ResponseData.Message == 'Successfully inserted') {
                   
                    if (type == 'draft') {
                        !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                    }
                    else {
                        NotificationTrigger({ title: "Evaluation", message: `${EmpName}'s performance evaluation has been posted`, route: `/performanceevaluation`, state: { state: { empId: details.empId, currentEvaluation: details.currentEvaluation, evaluationPeriodId: details.evaluationPeriodId, Domain: details.Domain, role: 'Manager' } }, to_employee: [resultData.data.reports_to], by: details.empId }, [resultData.data.reports_to], websocket).then(res => {
                            !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) : state?.redirect?.includes('tab') ? window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                        })
                    }


                }

            }
        }
    };

    const evaluationStatus = async (status) => {
        let validationForHr = validationHr(status);
        if (validationForHr) {
            let evaluationData = {
                evaluationId: evaluationId,
                status: status,
                hr_id: encryptStorage.getItem('employeeId'),
                comments: Evaluation.comments,
            };

            let updateStatus = await updateEvaluationStatus(evaluationData);
           
            if (updateStatus.data.ResponseData == 'successfully updated') {
               
                NotificationTrigger({ title: "Evaluation", message: `${EmpName}'s performance evaluation has been ${status}`, route: `/performanceevaluation`, state: { state: { empId: details.empId, currentEvaluation: details.currentEvaluation, evaluationPeriodId: details.evaluationPeriodId, Domain: details.Domain, role: 'Manager' } }, to_employee: [updateStatus.data.reports_to], by: encryptStorage.getItem('employeeId') }, [updateStatus.data.reports_to], websocket).then(res => {
                    NotificationTrigger({ title: "Evaluation", message: `Your performance evaluation has been ${status}`, route: `/performanceevaluation`, state: { state: { empId: details.empId, currentEvaluation: details.currentEvaluation, evaluationPeriodId: details.evaluationPeriodId, Domain: details.Domain, role: 'Team Member' } }, to_employee: [details.empId], by: encryptStorage.getItem('employeeId') }, [details.empId], websocket).then(res => {
                        !state?.View ? navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } }) :
                            state?.redirect?.includes('tab') ?
                                window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` :
                                window.location.href = `/profilecontainer${state.redirect}&tab=performance`;
                    })
                })

            }
        }
    };

    const bindGoal = (value, data) => {
        return value.map((goal, i) => {
            return (
                <div className="accordion-item border-0 performance-table">
                    <h2 className="accordion-header ps-4" id={'panelsStayOpen-heading' + i}>
                        <button
                            className="accordion-button-custom border-0 white-bg pb-3 bold-text font-15 align-item-center"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={'#panelsStayOpen-collapse' + data + i}
                            aria-expanded="true"
                            aria-controls={'panelsStayOpen-collapse' + data + i}
                        >
                            <span>
                                <img src="/Images/inner-accordian-target-img.svg" className="mb-2" />
                            </span>
                            <span className="px-3"> {goal.goal_name}</span>
                            <span className={`goalEvaStatus px-2 semibold-text font-10 inner-accordian-label ${goal.color} `}>{goal.status}</span>
                        </button>
                    </h2>
                    <div
                        id={'panelsStayOpen-collapse' + data + i}
                        className="accordion-collapse collapse show"
                        aria-labelledby={'panelsStayOpen-heading' + i}
                    >
                        <div className="accordion-body pt-0 px-0">
                            <div className="card-group performance-evaluation-card-group">
                                <div className="col-md-5 ">
                                    <div className="card rounded-0 border-start-0 inline-tablecontent-height">
                                        <div className="card-body ps-5  inline-table-spacing">
                                            <h5 className="card-title tt-bold font-15 text-blue">Team Member Comments</h5>
                                            <p className="card-text font-12 medium-text table-inlinetext-clr">{goal.employee_comments}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="card rounded-0 inline-tablecontent-height">
                                        <div className="card-body text-center align-self-center">
                                            <h5 className="card-title tt-bold font-15 text-blue">Rating
                                            </h5>
                                            {goal.employee_rating !== undefined &&
                                                goal.employee_rating !== '' &&
                                                goal.employee_rating !== null ? (
                                                <p className="card-text mt-3 tt-bold font-18 text-skyblue">
                                                    <img
                                                        src={
                                                            !goal.employee_rating
                                                                ? null : goal.employee_rating.includes('+') ? `/Images/${goal.employee_rating?.slice(0, -1)}_plus.png`
                                                                    : goal.employee_rating.includes('-') ? `/Images/${goal.employee_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" />
                                                    {goal.employee_rating}
                                                </p>
                                            ) : (
                                                <p className="card-text mt-3 tt-bold font-18 text-skyblue">-</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <div className="card rounded-0 inline-tablecontent-height">
                                        <div className="card-body ps-5">
                                            <h5 className="card-title tt-bold font-15 text-blue">Manager Comments</h5>
                                            <p className="card-text font-12 medium-text table-inlinetext-clr">{goal.manager_comments}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="card rounded-0 border-end-0 inline-tablecontent-height">
                                        <div className="card-body text-center align-self-center">
                                            <h5 className="card-title tt-bold font-15 text-blue">Rating</h5>
                                            {goal.manager_rating !== undefined &&
                                                goal.manager_rating !== '' &&
                                                goal.manager_rating !== null ? (
                                                <p className="card-text mt-3 tt-bold font-18 text-skyblue">

                                                    <img
                                                        src={
                                                            !goal.manager_rating
                                                                ? null : goal.manager_rating.includes('+') ? `/Images/${goal.manager_rating?.slice(0, -1)}_plus.png`
                                                                    : goal.manager_rating.includes('-') ? `/Images/${goal.manager_rating?.slice(0, -1)}_minus.png` : null
                                                        }
                                                        className="emoji-sty  me-2" />
                                                    {goal.manager_rating}
                                                </p>
                                            ) : (
                                                <p className="card-text mt-3 tt-bold font-18 text-skyblue">-</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    };

    const clickedLog = async (id) => {
       
        let getLog = await getIndividualLog({ logId: id })
       

        if (getLog.data.statusCode === 200) {
            setLogEvaluation(getLog.data.ResponseData.Evaluation)
            setLogImprove(getLog.data.ResponseData.ThingsToImprove)
            setLogTotal(getLog.data.ResponseData.Total)
            setLogShow(true)
        }
    }

    const evaluationPeriodTrigger = (value) => {
       

        setDetails({ ...details, endDate: value.endDate, currentEvaluation: value.currentEvaluation, evaluationPeriodId: value.id })
        // details.evaluationPeriodId(value.id)
    }

    return (
        <>
            <ReadMore />
            {logShow ? <EvaluationLog LogEvaluation={logEvaluation} LogTotal={logTotal} LogToImprove={logImprove} ThingsToImprove={thingsToImprove} Close={(value) => { setLogShow(value) }} /> : null}
            <div className="container-fluid mt-4">
                <div className="row">
                    <div className="col-md-12 bg-color px-5">
                        <div className="row align-items-center mt-5 mb-5">
                            <span style={{ "margin-left": "-15px" }}>
                                <BreadCrumbs data={breadCrumbsData} />
                            </span>
                            <div className="col-md-6">
                                <h5 className="font-15 bold-text text-blue mb-0">Performance Evaluation</h5>
                            </div>
                            <div className="col-md-6 d-flex align-items-center justify-content-end">
                                <label className="medium-text me-2 text-blue font-12">Evaluation Period</label>
                                <div className="btn-group border-0 me-2 " role="group" aria-label="Basic outlined example">
                                    <EvaluationButton dataChange={(value) => { evaluationPeriodTrigger(value) }} />
                                </div>
                                <div className="d-flex align-items-center">
                                    <div className="d-block">
                                        <img src="/Images/logo-person-user-person-icon.jpg" className="candidate-profile-pic" />
                                    </div>
                                    <div className="d-block ps-3 align-item-center">
                                        <h1 className="font-13 mb-0 semibold-text name-sty">{EmpName}</h1>
                                        <p className=" font-13 pb-0 pt-1 regular-text my-0">{EmpDomain}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Accordian starts here*/}
                        <div className="row mb-4">
                            <div className="accordion" id="accordionExample">
                                <div className="accordion-item border-0 performance-table">
                                    <h2 className="accordion-header mb-2 px-0 py-2 shadow-sm" id="goalevaluation">
                                        <button
                                            onClick={() => {
                                                setPyramid(false);
                                                setImproveFlag(false);
                                            }}
                                            className="accordion-button-custom border-0 white-bg ps-3 pb-3 bold-text font-15"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                        >
                                            Goal Evaluation
                                        </button>
                                    </h2>
                                    <div
                                        id="collapseOne"
                                        className="accordion-collapse collapse show"
                                        aria-labelledby="goalevaluation"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body px-0 pb-0">
                                            <div className="accordion" id="accordionPanelsStayOpenExample">
                                                {individualGoal ? bindGoal(individualGoal, 'indi') : null}
                                                {teamGoal ? bindGoal(teamGoal, 'team') : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item border-0 my-2 performance-table px-0">
                                    <h2 className="accordion-header px-0 py-2 shadow-sm" id="pyramidevaluation">
                                        <button
                                            onClick={() => {
                                                if (details.role == 'Team Member' && managerEvaluation[0]?.description === '') setPyramid(!Pyramid);
                                                else if (details.role == 'Manager') setImproveFlag(!ImproveFlag);

                                            }}
                                            className="accordion-button-custom collapsed border-0 ps-3 white-bg pb-3 bold-text font-15"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#collapsetwo"
                                            aria-expanded="true"
                                            aria-controls="collapsetwo"
                                        >
                                            Pyramid Evaluation{' '}
                                        </button>
                                        <span
                                            onClick={() => {
                                                $('#exampleModel').addClass('show');
                                                setReadMore(true);
                                            }}
                                        >
                                            <a
                                                data-bs-toggle="modal"
                                                data-bs-target="#ReadMore"
                                                className=" font-15 ms-2 text-skyblue text-decoration-none"
                                            >
                                                Read More
                                            </a>
                                        </span>
                                    </h2>
                                    <div
                                        id="collapsetwo"
                                        className=" accordion-collapse collapse"
                                        aria-labelledby="pyramidevaluation"
                                        data-bs-parent="#accordionExample"
                                    >
                                        <div className="accordion-body p-0">
                                            <div className="row mx-0 px-0">
                                                {details.role == 'Team Member' &&
                                                    managerEvaluation[0]?.description !== '' &&
                                                    managerEvaluation.length > 0 ? (
                                                    <>
                                                        <ViewEvaluation employeeEvaluation={employeeEvaluation} total={total[0]} title={"Self Evaluation"} />
                                                    </>
                                                ) : details.role == 'Team Member' && details.currentEvaluation == 1 && customStartEvaluation ? (
                                                    // <>
                                                    //     <div className="col-md-6 px-0 border-end">
                                                    //         <h5 className="border border-end-0 border-start-0 border-top-0 tt-bold font-15 ps-4 py-4 mb-0">
                                                    //             Self Evaluation
                                                    //         </h5>
                                                    //         <div className="row ps-4 m-0 pt-3">
                                                    //             <div className="col-md-8">
                                                    //                 <h6 className="font-12 bold-text pb-0">
                                                    //                     Attitude <span className="required"> *</span>
                                                    //                 </h6>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center">
                                                    //                 <h6 className="font-12 bold-text text-blue">Rating <span>
                                                    //                     <img src="/Images/help.svg" title="Ratings based on the total 
                                                    //                     1. Does not Meet Expectations
                                                    //                     2. Below Expectations
                                                    //                     3. Meets Expectations
                                                    //                     4. Sometimes Exceeding Expectations
                                                    //                     5. Always Exceeding Expectation" alt="help-icon" />
                                                    //                 </span></h6>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center">
                                                    //                 <h6 className="font-12 bold-text text-blue text-blue">Total</h6>
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pb-3">
                                                    //             <div className="col-md-8 align-self-center">
                                                    //                 <textarea
                                                    //                     name="description"
                                                    //                     value={employeeEvaluation[0].description}
                                                    //                     onChange={(e) => {
                                                    //                         onchangeEmp(e, 0);
                                                    //                     }}
                                                    //                     className="form-control performance-textarea-sty"
                                                    //                     id="exampleFormControlTextarea1"
                                                    //                     placeholder="Enter Comments"
                                                    //                     rows={3}
                                                    //                 />
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <div className="d-flex">
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <p className="font-14 mb-0 bold-text text-blue">4 * </p>
                                                    //                     </div>
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <select
                                                    //                             name="rating"
                                                    //                             value={employeeEvaluation[0].rating}
                                                    //                             onChange={(e) => {
                                                    //                                 onchangeRatingEmp(e, 0);
                                                    //                             }}
                                                    //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                    //                             aria-label="Default select example"
                                                    //                         >
                                                    //                             <option value={0} selected> </option>
                                                    //                             <option value={1}>1</option>
                                                    //                             <option value={2}>2</option>
                                                    //                             <option value={3}>3</option>
                                                    //                             <option value={4}>4</option>
                                                    //                             <option value={5}>5</option>
                                                    //                         </select>
                                                    //                     </div>
                                                    //                 </div>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <p className="font-14 bold-text text-blue">
                                                    //                     {employeeEvaluation[0].total == 0 ? null : employeeEvaluation[0].total}
                                                    //                 </p>
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                    //             <label
                                                    //                 htmlFor="exampleFormControlTextareae1"
                                                    //                 className="form-label text-blue font-12 bold-text"
                                                    //             >
                                                    //                 Communication<span className="required"> *</span>
                                                    //             </label>
                                                    //             <div className="col-md-8 align-self-center">
                                                    //                 <textarea
                                                    //                     value={employeeEvaluation[1].description}
                                                    //                     onChange={(e) => {
                                                    //                         onchangeEmp(e, 1);
                                                    //                     }}
                                                    //                     className="form-control performance-textarea-sty"
                                                    //                     id="exampleFormControlTextareae2"
                                                    //                     placeholder="Enter Comments"
                                                    //                     rows={3}
                                                    //                 />
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <div className="d-flex">
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <p className="font-14 mb-0 bold-text text-blue">3 * </p>
                                                    //                     </div>
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <select
                                                    //                             value={employeeEvaluation[1].rating}
                                                    //                             onChange={(e) => {
                                                    //                                 onchangeRatingEmp(e, 1);
                                                    //                             }}
                                                    //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                    //                             aria-label="Default select example"
                                                    //                         >
                                                    //                             <option value={0} selected> </option>
                                                    //                             <option value={1}>1</option>
                                                    //                             <option value={2}>2</option>
                                                    //                             <option value={3}>3</option>
                                                    //                             <option value={4}>4</option>
                                                    //                             <option value={5}>5</option>
                                                    //                         </select>
                                                    //                     </div>
                                                    //                 </div>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <p className="font-14 bold-text text-blue">
                                                    //                     {employeeEvaluation[1].total == 0 ? null : employeeEvaluation[1].total}
                                                    //                 </p>
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                    //             <label
                                                    //                 htmlFor="exampleFormControlTextareae3"
                                                    //                 className="form-label text-blue font-12 bold-text"
                                                    //             >
                                                    //                 Business<span className="required"> *</span>
                                                    //             </label>
                                                    //             <div className="col-md-8 align-self-center">
                                                    //                 <textarea
                                                    //                     value={employeeEvaluation[2]?.description}
                                                    //                     onChange={(e) => {
                                                    //                         onchangeEmp(e, 2);
                                                    //                     }}
                                                    //                     className="form-control performance-textarea-sty"
                                                    //                     id="exampleFormControlTextareae3"
                                                    //                     placeholder="Enter Comments"
                                                    //                     rows={3}
                                                    //                 />
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <div className="d-flex">
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <p className="font-14 mb-0 bold-text text-blue">2 * </p>
                                                    //                     </div>
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <select
                                                    //                             onChange={(e) => {
                                                    //                                 onchangeRatingEmp(e, 2);
                                                    //                             }}
                                                    //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                    //                             aria-label="Default select example"
                                                    //                             value={employeeEvaluation[2]?.rating}
                                                    //                         >
                                                    //                             <option value={0} selected> </option>
                                                    //                             <option value={1}>1</option>
                                                    //                             <option value={2}>2</option>
                                                    //                             <option value={3}>3</option>
                                                    //                             <option value={4}>4</option>
                                                    //                             <option value={5}>5</option>
                                                    //                         </select>
                                                    //                     </div>
                                                    //                 </div>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <p className="font-14 bold-text text-blue">
                                                    //                     {employeeEvaluation[2].total == 0 ? null : employeeEvaluation[2]?.total}
                                                    //                 </p>
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                    //             <label
                                                    //                 htmlFor="exampleFormControlTextareae4"
                                                    //                 className="form-label text-blue font-12 bold-text"
                                                    //             >
                                                    //                 Technology<span className="required"> *</span>
                                                    //             </label>
                                                    //             <div className="col-md-8 align-self-center">
                                                    //                 <textarea
                                                    //                     value={employeeEvaluation[3]?.description}
                                                    //                     onChange={(e) => {
                                                    //                         onchangeEmp(e, 3);
                                                    //                     }}
                                                    //                     className="form-control performance-textarea-sty"
                                                    //                     id="exampleFormControlTextareae4"
                                                    //                     placeholder="Enter Comments"
                                                    //                     rows={3}
                                                    //                 />
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <div className="d-flex">
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <p className="font-14 mb-0 bold-text text-blue">1 * </p>
                                                    //                     </div>
                                                    //                     <div className="d-block text-center align-self-center">
                                                    //                         <select
                                                    //                             value={employeeEvaluation[3]?.rating}
                                                    //                             onChange={(e) => {
                                                    //                                 onchangeRatingEmp(e, 3);
                                                    //                             }}
                                                    //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                    //                             aria-label="Default select example"
                                                    //                         >
                                                    //                             <option value={0} selected> </option>
                                                    //                             <option value={1}>1</option>
                                                    //                             <option value={2}>2</option>
                                                    //                             <option value={3}>3</option>
                                                    //                             <option value={4}>4</option>
                                                    //                             <option value={5}>5</option>
                                                    //                         </select>
                                                    //                     </div>
                                                    //                 </div>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 <p className="font-14 bold-text text-blue">
                                                    //                     {employeeEvaluation[3].total == 0 ? null : employeeEvaluation[3]?.total}
                                                    //                 </p>
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pt-3">
                                                    //             <div className="col-md-10 text-end align-self-center">
                                                    //                 <p className="font-14 bold-text text-blue pe-4">Total</p>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center align-self-center">
                                                    //                 {total[0]?.grand_total == 0 ? (
                                                    //                     <p className="font-14 bold-text text-blue">-</p>
                                                    //                 ) : (
                                                    //                     <p className="font-14 bold-text text-blue">

                                                    //                         {total[0]?.grand_total}
                                                    //                     </p>
                                                    //                 )}
                                                    //             </div>
                                                    //         </div>
                                                    //         <div className="row ps-4 m-0 pt-3">
                                                    //             <div className="col-md-10 text-end">
                                                    //                 <p className="font-14 bold-text text-blue align-self-center pe-4">
                                                    //                     Rating based on evaluation{' '}
                                                    //                     <span>
                                                    //                         <img src="/Images/help.svg" title="
                                                    //                         Ratings based on the total 
                                                    //                         44-50 = A+
                                                    //                         37-43 = A-
                                                    //                         30-36 = B+
                                                    //                         24-30 = B-
                                                    //                         17-23 = C+
                                                    //                         10-16 = C-"
                                                    //                             alt="help-icon" />
                                                    //                     </span>
                                                    //                 </p>
                                                    //             </div>
                                                    //             <div className="col-md-2 text-center px-2">
                                                    //                 <p className="card-text tt-bold font-18 text-skyblue">
                                                    //                     {total[0]?.grand_rating ? <img

                                                    //                         src={
                                                    //                             !total[0]?.grand_rating
                                                    //                                 ? null : total[0]?.grand_rating.includes('+') ? `/Images/${total[0]?.grand_rating?.slice(0, -1)}_plus.png`
                                                    //                                     : total[0]?.grand_rating.includes('-') ? `/Images/${total[0]?.grand_rating?.slice(0, -1)}_minus.png` : null
                                                    //                         }
                                                    //                         className="emoji-sty  me-2" /> : null}
                                                    //                     {total[0]?.grand_rating}
                                                    //                 </p>
                                                    //             </div>
                                                    //         </div>
                                                    //     </div>
                                                    // </>
                                                    <EmpEvaluation title={'Self Evaluation'} validate={employeeValidation} Eva={employeeEvaluation} onChangeTrigger={onchangeEmp} onChangeRating={onchangeRatingEmp} index={0} totalShow={total} stateToSet={setEmployeeEvaluation} />
                                                ) :
                                                    details.role == 'Team Member' && employeeEvaluation.length > 0 && employeeEvaluation[0]?.description !== '' ?
                                                        <ViewEvaluation employeeEvaluation={employeeEvaluation} total={total[0]} title={"Self Evaluation"} />
                                                        : details.role == 'Team Member' ?
                                                            <EvaluationNoData Title={"Team Member Evaluation"} />
                                                            : null
                                                }

                                                {details.role == 'Manager' &&
                                                    employeeEvaluation[0]?.description !== '' &&
                                                    employeeEvaluation.length > 0 ? (
                                                    <>
                                                        <ViewEvaluation employeeEvaluation={employeeEvaluation} total={total[0]} title={"Team Memeber Evaluation"} />
                                                    </>
                                                ) : details.role == 'Manager' ? (
                                                    <>
                                                        <EvaluationNoData Title={"Team Member Evaluation"} />
                                                    </>
                                                ) : null}

                                                {details.role == 'Hr Manager' && employeeEvaluation[0]?.description !== '' ? (
                                                    <>
                                                        <ViewEvaluation employeeEvaluation={employeeEvaluation} total={total[0]} title={"Team Memeber Evaluation"} />
                                                    </>
                                                ) : details.role == 'Hr Manager' ? (
                                                    <>
                                                        <EvaluationNoData Title={"Team Member Evaluation"} />
                                                    </>
                                                ) : null}

                                                {details.role === 'Manager' && evaStatus === 'Approved' ?
                                                    <ViewEvaluation employeeEvaluation={managerEvaluation} total={total[1]} title={"Manager Evaluation"} />
                                                    :
                                                    details.role == 'Manager' && employeeEvaluation[0].description != '' && details.currentEvaluation == 1 && customStartEvaluation ? (
                                                        <EmpEvaluation title={'Manager Evaluation'} validate={managerValidation} Eva={managerEvaluation} onChangeTrigger={onchangeEmp} onChangeRating={onchangeRatingEmp} index={1} totalShow={total} stateToSet={setManagerEvaluation} />

                                                        //    <div className="col-md-6 px-0 border-end">
                                                        //         <h5 className="border border-end-0 border-start-0 border-top-0 tt-bold font-15 ps-4 py-4 mb-0">
                                                        //             Manager Evaluation
                                                        //         </h5>
                                                        //         <div className="row ps-4 m-0 pt-3">
                                                        //             <div className="col-md-8">
                                                        //                 <h6 className="font-12 bold-text pb-0">
                                                        //                     Attitude <span className="required"> *</span>
                                                        //                 </h6>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center">
                                                        //                 <h6 className="font-12 bold-text text-blue">Rating <span>
                                                        //                     <img src="/Images/help.svg" title="Ratings based on the total 
                                                        //                     1. Does not Meet Expectations
                                                        //                     2. Below Expectations
                                                        //                     3. Meets Expectations
                                                        //                     4. Sometimes Exceeding Expectations
                                                        //                     5. Always Exceeding Expectation" alt="help-icon" />
                                                        //                 </span></h6>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center">
                                                        //                 <h6 className="font-12 bold-text text-blue text-blue">Total</h6>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pb-3">
                                                        //             <div className="col-md-8 align-self-center">
                                                        //                 <textarea
                                                        //                     name="description"
                                                        //                     value={managerEvaluation[0]?.description}
                                                        //                     onChange={(e) => {
                                                        //                         onchangeManager(e, 0);
                                                        //                     }}
                                                        //                     className="form-control performance-textarea-sty"
                                                        //                     id="exampleFormControlTextaream1"
                                                        //                     placeholder="Enter Comments"
                                                        //                     rows={3}
                                                        //                 />
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <div className="d-flex">
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <p className="font-14 mb-0 bold-text text-blue">4 * </p>
                                                        //                     </div>
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <select
                                                        //                             name="rating"
                                                        //                             value={managerEvaluation[0]?.rating}
                                                        //                             onChange={(e) => {
                                                        //                                 onchangeRatingManager(e, 0);
                                                        //                             }}
                                                        //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                        //                             aria-label="Default select example"
                                                        //                         >
                                                        //                             <option value={0} selected> </option>
                                                        //                             <option value={1}>1</option>
                                                        //                             <option value={2}>2</option>
                                                        //                             <option value={3}>3</option>
                                                        //                             <option value={4}>4</option>
                                                        //                             <option value={5}>5</option>
                                                        //                         </select>
                                                        //                     </div>
                                                        //                 </div>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue">

                                                        //                     {managerEvaluation[0].total == 0 ? null : managerEvaluation[0]?.total}
                                                        //                 </p>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                        //             <label
                                                        //                 htmlFor="exampleFormControlTextareae1"
                                                        //                 className="form-label text-blue font-12 bold-text"
                                                        //             >
                                                        //                 Communication<span className="required"> *</span>
                                                        //             </label>
                                                        //             <div className="col-md-8 align-self-center">
                                                        //                 <textarea
                                                        //                     value={managerEvaluation[1]?.description}
                                                        //                     onChange={(e) => {
                                                        //                         onchangeManager(e, 1);
                                                        //                     }}
                                                        //                     className="form-control performance-textarea-sty"
                                                        //                     id="exampleFormControlTextaream2"
                                                        //                     placeholder="Enter Comments"
                                                        //                     rows={3}
                                                        //                 />
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <div className="d-flex">
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <p className="font-14 mb-0 bold-text text-blue">3 * </p>
                                                        //                     </div>
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <select
                                                        //                             value={managerEvaluation[1]?.rating}
                                                        //                             onChange={(e) => {
                                                        //                                 onchangeRatingManager(e, 1);
                                                        //                             }}
                                                        //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                        //                             aria-label="Default select example"
                                                        //                         >
                                                        //                             <option value={0} selected> </option>
                                                        //                             <option value={1}>1</option>
                                                        //                             <option value={2}>2</option>
                                                        //                             <option value={3}>3</option>
                                                        //                             <option value={4}>4</option>
                                                        //                             <option value={5}>5</option>
                                                        //                         </select>
                                                        //                     </div>
                                                        //                 </div>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue">{managerEvaluation[1].total == 0 ? null : managerEvaluation[1]?.total}</p>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                        //             <label
                                                        //                 htmlFor="exampleFormControlTextareae3"
                                                        //                 className="form-label text-blue font-12 bold-text"
                                                        //             >
                                                        //                 Business<span className="required"> *</span>
                                                        //             </label>
                                                        //             <div className="col-md-8 align-self-center">
                                                        //                 <textarea
                                                        //                     value={managerEvaluation[2]?.description}
                                                        //                     onChange={(e) => {
                                                        //                         onchangeManager(e, 2);
                                                        //                     }}
                                                        //                     className="form-control performance-textarea-sty"
                                                        //                     id="exampleFormControlTextaream3"
                                                        //                     placeholder="Enter Comments"
                                                        //                     rows={3}
                                                        //                 />
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <div className="d-flex">
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <p className="font-14 mb-0 bold-text text-blue">2 * </p>
                                                        //                     </div>
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <select
                                                        //                             onChange={(e) => {
                                                        //                                 onchangeRatingManager(e, 2);
                                                        //                             }}
                                                        //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                        //                             aria-label="Default select example"
                                                        //                             value={managerEvaluation[2]?.rating}
                                                        //                         >
                                                        //                             <option value={0} selected> </option>
                                                        //                             <option value={1}>1</option>
                                                        //                             <option value={2}>2</option>
                                                        //                             <option value={3}>3</option>
                                                        //                             <option value={4}>4</option>
                                                        //                             <option value={5}>5</option>
                                                        //                         </select>
                                                        //                     </div>
                                                        //                 </div>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue">{managerEvaluation[2].total == 0 ? null : managerEvaluation[2]?.total}</p>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pt-3 pb-3">
                                                        //             <label
                                                        //                 htmlFor="exampleFormControlTextareae4"
                                                        //                 className="form-label text-blue font-12 bold-text"
                                                        //             >
                                                        //                 Technology<span className="required"> *</span>
                                                        //             </label>
                                                        //             <div className="col-md-8 align-self-center">
                                                        //                 <textarea
                                                        //                     value={managerEvaluation[3]?.description}
                                                        //                     onChange={(e) => {
                                                        //                         onchangeManager(e, 3);
                                                        //                     }}
                                                        //                     className="form-control performance-textarea-sty"
                                                        //                     id="exampleFormControlTextaream4"
                                                        //                     placeholder="Enter Comments"
                                                        //                     rows={3}
                                                        //                 />
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <div className="d-flex">
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <p className="font-14 mb-0 bold-text text-blue">1 * </p>
                                                        //                     </div>
                                                        //                     <div className="d-block text-center align-self-center">
                                                        //                         <select
                                                        //                             value={managerEvaluation[3]?.rating}
                                                        //                             onChange={(e) => {
                                                        //                                 onchangeRatingManager(e, 3);
                                                        //                             }}
                                                        //                             className="form-select ms-1 select-box-sty font-14 bold-text text-blue"
                                                        //                             aria-label="Default select example"
                                                        //                         >
                                                        //                             <option value={0} selected> </option>
                                                        //                             <option value={1}>1</option>
                                                        //                             <option value={2}>2</option>
                                                        //                             <option value={3}>3</option>
                                                        //                             <option value={4}>4</option>
                                                        //                             <option value={5}>5</option>
                                                        //                         </select>
                                                        //                     </div>
                                                        //                 </div>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue">{managerEvaluation[3].total == 0 ? null : managerEvaluation[3]?.total}</p>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pt-3">
                                                        //             <div className="col-md-10 text-end align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue pe-4">Total</p>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center align-self-center">
                                                        //                 <p className="font-14 bold-text text-blue"> {total[1]?.grand_total}</p>
                                                        //             </div>
                                                        //         </div>
                                                        //         <div className="row ps-4 m-0 pt-3">
                                                        //             <div className="col-md-10 text-end">
                                                        //                 <p className="font-14 bold-text text-blue align-self-center pe-4">
                                                        //                     Rating based on evaluation{' '}
                                                        //                     <span>
                                                        //                         <img src="/Images/help.svg" title="Ratings based on the total 
                                                        //                     44-50 = A+
                                                        //                     37-43 = A-
                                                        //                     30-36 = B+
                                                        //                     24-30 = B-
                                                        //                     17-23 = C+
                                                        //                     10-16 = C-"  alt="help-icon" />
                                                        //                     </span>
                                                        //                 </p>
                                                        //             </div>
                                                        //             <div className="col-md-2 text-center px-2">
                                                        //                 <p className="card-text tt-bold font-18 text-skyblue ">
                                                        //                     {total[1]?.grand_rating ?
                                                        //                         <img
                                                        //                             src={
                                                        //                                 !total[1]?.grand_rating
                                                        //                                     ? null : total[1]?.grand_rating.includes('+') ? `/Images/${total[1]?.grand_rating?.slice(0, -1)}_plus.png`
                                                        //                                         : total[1]?.grand_rating.includes('-') ? `/Images/${total[1]?.grand_rating?.slice(0, -1)}_minus.png` : null
                                                        //                             }
                                                        //                             className="emoji-sty  me-2" /> : null}
                                                        //                     {total[1]?.grand_rating}
                                                        //                 </p>
                                                        //             </div>
                                                        //         </div>
                                                        //     </div>
                                                    )
                                                        : details.role == 'Manager' && managerEvaluation.length > 0 && managerEvaluation[0]?.description !== '' ?
                                                            <ViewEvaluation employeeEvaluation={managerEvaluation} total={total[1]} title={"Manager Evaluation"} />

                                                            : details.role == 'Manager' ?
                                                                <EvaluationNoData Title={"Manager Evaluation"} Subtitle={"Team Member has to fill the Evaluation"} />
                                                                : null
                                                }

                                                {details.role == 'Team Member' &&
                                                    managerEvaluation[0]?.description !== '' &&
                                                    managerEvaluation.length > 0 ? (
                                                    <>

                                                        <ViewEvaluation employeeEvaluation={managerEvaluation} total={total[1]} title={"Manager Evaluation"} />
                                                    </>
                                                ) : details.role == 'Team Member' && details.currentEvaluation == 1 ? (
                                                    <>
                                                        <EvaluationNoData Title={"Manager Evaluation"} Subtitle={"Finish your evaluation fast, Manager waiting to his evaluation"} />
                                                    </>
                                                ) : details.role == 'Team Member' ?
                                                    <EvaluationNoData Title={"Manager Evaluation"} />
                                                    : null

                                                }

                                                {details.role == 'Hr Manager' && managerEvaluation[0]?.description !== '' ? (
                                                    <>
                                                        <ViewEvaluation employeeEvaluation={managerEvaluation} total={total[1]} title={"Manager Evaluation"} />

                                                    </>
                                                ) : details.role == 'Hr Manager' ? (
                                                    <>
                                                        <EvaluationNoData Title={"Manager Evaluation"} />
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {details.role == 'Manager' && evaStatus !== 'Approved' && details.currentEvaluation == 1 && customStartEvaluation ? (
                                    <div className="accordion-item my-2 border-0 px-0 performance-table">
                                        <h2 className="accordion-header mb-2 px-0 py-2 shadow-sm" id="thingstoimprove">
                                            <button
                                                onClick={() => {
                                                   
                                                    showThingsToImprove();
                                                    setImproveFlag(true);
                                                }}
                                                className="accordion-button-custom collapsed border-0 white-bg ps-3 pb-3 bold-text font-15"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapsethree"
                                                aria-expanded="true"
                                                aria-controls="collapseOne"
                                            >
                                                Things to Improve
                                            </button>
                                        </h2>
                                        <div
                                            id="collapsethree"
                                            className="accordion-collapse collapse"
                                            aria-labelledby="thingstoimprove"
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body px-5">
                                                {thingsToImprove ? bindThingsToImprove() : null}
                                                {newtti.length > 0 ? CheckBox() : null}
                                                <div
                                                    className="border-line py-3"
                                                    onClick={() => {
                                                        AddCheckBox();
                                                    }}
                                                >
                                                    <a className=" text-decoration-none text-skyblue font-13 semibold-text">
                                                        + Add Things to Improve
                                                    </a>
                                                </div>

                                                {/* {CheckBox()} */}
                                            </div>
                                        </div>
                                    </div>
                                ) : thingsToImproveEvaluation.length > 0 && managerEvaluation[0]?.description !== '' ? (
                                    <>
                                        <div className="accordion-item my-2 border-0 px-0 performance-table">
                                            <h2 className="accordion-header mb-2 px-0 py-2 shadow-sm" id="thingstoimprove">
                                                <button
                                                    onClick={() => {
                                                        showThingsToImprove();
                                                        setImproveFlag(!ImproveFlag);
                                                    }}
                                                    className="accordion-button-custom collapsed border-0 white-bg ps-3 pb-3 bold-text font-15"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#collapsethree"
                                                    aria-expanded="true"
                                                    aria-controls="collapseOne"
                                                >
                                                    Things to Improve
                                                </button>
                                            </h2>
                                            <div
                                                id="collapsethree"
                                                className="accordion-collapse collapse"
                                                aria-labelledby="thingstoimprove"
                                                data-bs-parent="#accordionExample"
                                            >
                                                <div className="accordion-body px-5">
                                                    <div className="form-check my-1">{bindData()}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>
                        {/*Accordian ends here*/}
                        {details.role == 'Hr Manager' && details.currentEvaluation == 1 && customStartEvaluation && evaStatus !== 'Approved' ? (
                            <>
                                <div class="row mt-3 pb-5">
                                    <div class="col-md-12">
                                        <label class="form-label hive-form-label w-100">HR Comments<span className="required"> *</span></label>
                                        <textarea
                                            value={Evaluation.comments}
                                            name="comments"
                                            onChange={(e) => {
                                                setEvaluation({ ...Evaluation, [e.target.name]: e.target.value });
                                            }}
                                            class="form-control hive-form-control hive-hr-comments" placeholder="Enter Comments"></textarea>
                                        <label className='text-danger'>{HrComments}</label>
                                    </div>
                                </div>
                            </>
                        ) : evaStatus !== 'pending' && evaStatus !== '' ? <>
                            <div class="row mt-3 pb-5">
                                <div class="col-md-12">
                                    <label class="form-label hive-form-label w-100">HR Comments<span className={evaStatus === 'Approved' ? "bg-pastel-green" : "bg-pastel-red"}> &#9679; {evaStatus}</span></label>
                                    <textarea
                                        disabled
                                        value={Evaluation.comments}
                                        name="comments"
                                        class="form-control hive-form-control hive-hr-comments" placeholder="Enter Comments"></textarea>
                                </div>
                            </div>
                        </> : null}

                        <div className="row pt-5">
                            <div className="d-flex justify-content-end mb-3">
                                <a style={{ textDecoration: 'none' }} onClick={() => {
                                    if (!state?.View) navigate('/performance', { state: { tab: details.role == 'Manager' || details.role == 'Hr Manager' ? 'orggoal' : '' } })
                                    else {
                                        window.location.href = state?.redirect?.includes('tab') ? `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance` : `/profilecontainer${state.redirect}&tab=performance`
                                    }
                                }} >
                                    <button type="button" className="btn hive-btn-secondary me-3">
                                        Cancel
                                    </button>
                                </a>
                                {details.role == 'Hr Manager' && evaStatus !== 'Approved' && managerEvaluation[0]?.description !== '' && details.currentEvaluation == 1 && customStartEvaluation ? (
                                    <>
                                        <button type="button" style={{ textDecoration: 'none' }}
                                            onClick={() => {
                                                evaluationStatus('Rejected');
                                            }} class="btn secondary-button hive-btn-reject me-3">Reject
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn hive-btn-primary"
                                            onClick={() => {
                                                evaluationStatus('Approved');
                                            }}
                                        >
                                            Approve
                                        </button>
                                    </>
                                ) :
                                    null}

                                {Pyramid && validation(employeeEvaluation) && details.role == 'Team Member' && customStartEvaluation && details.currentEvaluation == 1 && evaStatus !== 'Approved' ? (
                                    <>
                                        <button
                                            type="button"
                                            className="btn hive-btn-outline me-3"
                                            onClick={() => {
                                                // let validate = validation(employeeEvaluation)
                                                // if (validate) {
                                                saveEvaluation('pyramid', 'draft');
                                                // }
                                            }}
                                        >
                                            Save as Draft
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn hive-btn-primary"
                                            onClick={() => {
                                                // let validate = validation(employeeEvaluation)
                                                // if (validate) {
                                                saveEvaluation('pyramid', 'publish');
                                                // }
                                            }}
                                        >
                                            Submit Evaluation
                                        </button>
                                    </>
                                ) : null}


                                {ImproveFlag && validation(managerEvaluation) && details.role == 'Manager' && evaStatus !== 'Approved' && details.currentEvaluation == 1 && customStartEvaluation ? (
                                    <>
                                        <button
                                            type="button"
                                            className="btn hive-btn-outline me-3"
                                            onClick={() => {
                                                saveEvaluation('improve', 'draft');
                                            }}
                                        >
                                            Save as Draft
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn hive-btn-primary"
                                            onClick={() => {
                                                saveEvaluation('improve', 'publish');
                                            }}
                                        >
                                            Submit Evaluation
                                        </button>{' '}
                                    </>
                                ) : null}
                            </div>
                        </div>
                        {details.role === 'Hr Manager' || details.role === 'Manager' ? (
                            <div className="table-responsive rounded-3">
                                <table className="table bg-white hive-grid table-borderless mt-3">
                                    <thead className="hive-table-head ">
                                        <tr>
                                            <th className="bold-text font-12">Date Range</th>
                                            <th className="bold-text font-12">Username</th>
                                            {/* <th className="text-center bold-text font-12">Action</th> */}
                                            <th className="text-center bold-text font-12">Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logs?.map((log) => {
                                            return (
                                                <tr className="hive-table-data regular-text align-middle">
                                                    <td>{moment(log.created_at).format('MMM DD, YYYY hh:mmA')}</td>
                                                    <td>{log.emp_name}</td>
                                                    {/* <td className="text-center bold-text ">{log.action}</td> */}
                                                    <td onClick={() => { let a = (log.action.includes('Rejected') || log.action.includes('Approved')) ? null : clickedLog(log.id) }}
                                                        className="text-center ">
                                                        {log.action.includes('Rejected') || log.action.includes('Approved') ? <a className="text-decoration-none table-link-clr">{log.action}</a> :
                                                            <a className="text-decoration-none table-link-clr cursor">View Audit History</a>}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </>
    );
}


function mapStateToProps(state) {

    return {
        websocket: state.webSocketAPI
    }
}

export default connect(mapStateToProps)(PerformanceEvaluation)
